const CHANGE_SELECTED_DATE = "CHANGE_SELECTED_DATE";
const TOGGLE_IS_EDITING_DATE = "TOGGLE_IS_EDITING_DATE";
const CHANGE_SELECTED_MONTH = "CHANGE_SELECTED_MONTH";
const CHANGE_SELECTED_YEAR = "CHANGE_SELECTED_YEAR";

export { 
    CHANGE_SELECTED_DATE, 
    TOGGLE_IS_EDITING_DATE, 
    CHANGE_SELECTED_MONTH, 
    CHANGE_SELECTED_YEAR };